import Icon from '../Icon.vue'

Icon.register({
  'browser': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M18.125 0H1.875C.84 0 0 .84 0 1.875v13.75C0 16.66.84 17.5 1.875 17.5h16.25c1.035 0 1.875-.84 1.875-1.875V1.875C20 .84 19.16 0 18.125 0zM5 4.531A.47.47 0 014.531 5H2.97a.47.47 0 01-.469-.469V2.97a.47.47 0 01.469-.469h1.56a.47.47 0 01.47.468V4.53zm12.5 0a.47.47 0 01-.469.469H7.344a.47.47 0 01-.469-.469V2.97a.47.47 0 01.469-.469h9.687a.47.47 0 01.469.469v1.56zm-3.383 8.876l-1.894 1.98c-.084.088-.223.025-.223-.1V7.142c0-.124.136-.188.22-.104l5.737 5.701c.09.09.029.245-.089.245h-2.66l1.094 2.489c.033.074-.002.165-.075.193l-.844.326c-.066.025-.134-.01-.162-.073l-1.104-2.512z'
      }
    ]
  }
})
